import { OptionsSharesSubscriptionNote } from './OptionsSharesSubscriptionNote';
import { Stack } from '@startuptools/ui/Stack';
import {
  type GqlIdentity,
  type GqlMeetingConcern,
  type GqlOptionsSharesSubscriber,
  type GqlWarrantProgram,
} from '../../../../graphql/base-types.graphql';
import { type DisplayDocument } from '@startuptools/business-ui/document/Document';

export const OptionsSharesSubscriptionNoteList = ({
  optionsSharesRegistration,
  warrantProgram,
}: {
  optionsSharesRegistration: {
    subscribers: (Pick<GqlOptionsSharesSubscriber, 'id' | 'optionsSharesRegistrationId'> & {
      identity: Pick<GqlIdentity, 'id' | 'name'>;
      latestShareSubscriptionListDoc?: DisplayDocument | null;
    })[];
  };
  warrantProgram: Pick<GqlWarrantProgram, 'description' | 'companyId' | 'paidForAt'> & {
    meetingConcern?: Pick<GqlMeetingConcern, 'meetingId'> | null;
  };
}) => {
  return (
    <Stack gap={1}>
      {optionsSharesRegistration.subscribers.map(oss => (
        <OptionsSharesSubscriptionNote key={oss.id} subscriber={oss} warrantProgram={warrantProgram} />
      ))}
    </Stack>
  );
};
